<template>
  <van-swipe-cell :disabled="disableSwipe">
    <div class="item-main"
      @click="detail(data)">
      <!-- <div class="item-img">
        <van-image width="4rem"
          height="4rem"
          :src="data.logo" />
      </div> -->

      <div class="item-info">
        <div class="item-col item-info-detalis">
          <div class="item-head"
            style="padding-bottom: 0.5rem;">
            <div class="head-name"
              v-text="data.name"></div>
          </div>
          <!-- <div class="item-prefer" v-if="showPrefer">
                        <span>关联 <span style="color:#d04a02;">{{data.relationCount}}</span> 条PwC关系</span>
                    </div> -->
          <div class="item-position">
            <span v-text="data.peorganizationName"></span> <span v-if="data.titleName!=null"> </span>
            <span v-text="data.titleName"></span>
          </div>
          <div class="item-position">
            <span v-text="userIndustry(data.userIndustry)"> </span>
          </div>
          <div class="div-chk"
            v-show="showChk">
            <van-checkbox v-model="data.checked"
              checked-color="#c52a1a"></van-checkbox>
          </div>
        </div>
        <div class="iknow">
          <van-button v-if="data.alreadyKnown"
            class="iknow-button known"
            plain
            @click.stop.prevent="editRelationship(data.relationshipId)"> {{$t('recognized')}}</van-button>
          <van-button v-else
            class="iknow-button"
            plain
            @click.stop.prevent="ikonw(data.id)">我认识他/她</van-button>

          <div class="item-prefer"
            style="padding-top: 5px;"
            v-if="showPrefer">
            <span>关联 <span style="color:#d04a02;">{{data.relationCount}}</span> 条PwC关系</span>
          </div>
        </div>
      </div>
    </div>
    <template #right>
      <div class="cell-right"
        @click="cancelMark(data.id)">
        &nbsp;&nbsp; 取消收藏&nbsp;&nbsp;
      </div>
    </template>
  </van-swipe-cell>
</template>

<script>
import { Dialog } from "vant";
export default {
  data () {
    return {
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    showChk: {
      type: Boolean,
      required: false,
    },
    disableSwipe: {
      type: Boolean,
      required: false,
      default: true,
    },
    showPrefer: {
      type: Boolean,
      required: false,
      default: true,
    },
    showKnow: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {},
  computed: {},
  mounted () {
    console.log("group:");
    console.log(this.data);
  },
  methods: {
    editRelationship (relId) {
      this.$router.push({
        path: "/home/addRelationship",
        query: {
          relationshipId: relId,
          type: "org",
          isEdit: true,
        },
      });
    },
    ikonw (id) {
      this.$router.push({
        path: "/home/addRelationship",
        query: {
          id: id,
        },
      });
    },
    cancelMark (id) {
      Dialog.confirm({
        title: "提示",
        message: "确认取消收藏该联系人",
      })
        .then(() => {
          //request

          this.$emit("cancel", id);
        })
        .catch(() => {
          // on cancel
        });
    },
    detail (item) {
      if (item.alreadyKnown) {
        if (!this.showChk) {
          this.$router.push({
            path: "/contractorDetail",
            query: {
              id: item.id,
              editId: item.relationshipId
            },
          });
        }
      } else {
        if (!this.showChk) {
          this.$router.push({
            path: "/contractorDetail",
            query: {
              id: item.id,
            },
          });
        }
      }
    },
    userIndustry (item) {
      //处理专注行业
      let userIndustry = '';
      if (!_.isEmpty(item) && item.length > 0) {
        let industries = _.split(item, ',');
        if (industries.length < 4) {
          userIndustry = _.join(industries, '，');
        }
        else {
          let firstThr = _.slice(industries, 0, 3);
          let otherInd = _.slice(industries, 3, industries.length);
          userIndustry = _.join(firstThr, '，');
        }
      }
      return userIndustry;
    }
  },
};
</script>
<style lang='scss' scoped>
.item-main {
  display: flex;
  padding: 0.375rem;
  border-bottom: 1px solid #f2f2f2;
  .item-info-detalis {
    flex-grow: 1;
  }
  .iknow {
    //align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    //padding-right: 10px;
  }
  .iknow-button {
    height: 22px;
    padding: 0px;
    font-size: 12px;
    color: #c52a1a;
    border-color: #c52a1a;
  }
  .known {
    color: #7d7d7d;
    border-color: #7d7d7d;
  }
  .item-img {
    padding: 0.25rem;
  }
  .item-info {
    padding: 0.25rem;
    display: flex;
    width: 100%;
    justify-content: space-between;
    position: relative;
    margin: 0px 1rem;
    .item-head {
      display: flex;
      .head-name {
        color: #2d2d2d;
        //font-size: 1rem;
        font-weight: bolder;
        width: 70%;
        font-size: 0.875rem;
      }
    }
    .item-prefer,
    .item-position {
      //padding: 0.25rem 0;
      color: #7d7d7d;
      font-size: 0.75rem;
      padding-bottom: 2px;
      //word-break: keep-all;
    }
    .div-chk {
      position: absolute;
      right: -20px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
.cell-right {
  text-align: center;
  height: 100%;
  display: flex;
  align-items: center;
  // background-color: #7d7d7d;
  //color: rgb(209, 89, 11);
  color: #c52a1a;
}
</style>


// WEBPACK FOOTER //
// src/components/content/contractor/ContractorItem.vue